export const CURRENT_TOS_VERSION = 2;
export const TOS_FIELDS = {
  ACCEPTED_AT: 'tosAcceptedAt',
  ACCEPTED_VERSION: 'tosAcceptedVersion',
} as const;
